import type { DevicePosition } from '@/lib/platform/types';

/**
 * The last position the app determined (the "shopping at" proposal asks for one when the
 * permission was given). A check-off made while it is fresh carries it – so a scan in the store
 * remembers where the purchase happened (user, 2026-09-24). Nothing here asks for the position;
 * without one, nothing is stored.
 */
const FRESH_MS = 30 * 60_000;
let last: DevicePosition | null = null;

export function rememberPosition(position: DevicePosition): void {
  last = position;
}

export function lastKnownPosition(maxAgeMs = FRESH_MS): { lat: number; lng: number } | null {
  if (!last || Date.now() - last.timestamp > maxAgeMs) return null;
  // Six decimals, like the stores: about 10 cm, more than any receiver knows.
  return { lat: Number(last.lat.toFixed(6)), lng: Number(last.lng.toFixed(6)) };
}

/** For tests and sign-out. */
export function forgetPosition(): void {
  last = null;
}
